import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

const config = {
  skcy: 'p5ppj4y4'
}

async function getKeyAndIv() {
  const secret = config.skcy
  const encoder = new TextEncoder();
  const keyMaterial = await crypto.subtle.digest("SHA-256", encoder.encode(secret));
  const key = await crypto.subtle.importKey(
    "raw",
    keyMaterial,
    { name: "AES-CBC" },
    false,
    ["encrypt", "decrypt"]
  );
  const iv = new Uint8Array(keyMaterial).slice(0, 16); // same as PHP
  return { key, iv };
}

export async function encryptString(plainText) {
  const { key, iv } = await getKeyAndIv();
  const encoded = new TextEncoder().encode(plainText);
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    encoded
  );
  return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

export async function decryptString(encryptedText) {
  const { key, iv } = await getKeyAndIv();
  const binary = atob(encryptedText);
  const encryptedBytes = new Uint8Array([...binary].map(char => char.charCodeAt(0)));
  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    encryptedBytes
  );
  return new TextDecoder().decode(decrypted);
}

Vue.directive("uppercase", {
  update(el) {
    el.value = el.value.toUpperCase();
  },
});

Vue.directive("lowercase", {
  update(el) {
    el.value = el.value.toLowerCase();
  },
});

Vue.directive("nik", {
  update(el) {
    let digitsOnly = el.value.replace(/\D/g, "");
    const regex = /^(\d{4})(\d{2})(\d{6})(\d{4})$/;
    el.value = digitsOnly.replace(regex, "$1-$2-$3-$4");
  },
});

Vue.directive("nohp", {
  update(el) {
    let digitsOnly = el.value.replace(/\D/g, "");

    if (digitsOnly[0] != 8) {
      digitsOnly = "";
    }

    el.value = digitsOnly;
    el.value = el.value.replace(/\B(?=(\d{4})+(?!\d))/g, "-");
  },
});

Vue.filter('number', function (value) {
  if (value || value == 0) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  } else return '';
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
